export class HttpException
extends Error
{
	public readonly code: number;

	constructor(message: string = "Internal Server Error", code: number = 500) {
		super(message);
		this.code = code;
	}
}